
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weddings",
      function () {
        return require("private-next-pages/weddings.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weddings"])
      });
    }
  